import React, { useState, useEffect, useCallback } from "react";
import { Container, Box } from "@material-ui/core";
import {
  Typography,
  AppBar,
  Toolbar,
  Link,
  CardActionArea,
  TextField,
  Button,
  Paper,
  FormControlLabel,
  Checkbox,
} from "@material-ui/core";
import {
  Grid,
  Dialog,
  DialogActions,
  DialogTitle,
  DialogContent,
  DialogContentText,
  LinearProgress,
  Select,
  FormHelperText,
  InputLabel,
  MenuItem,
  FormControl,
  CircularProgress,
  IconButton,
} from "@material-ui/core";
import {
  DesktopMac,
  Add,
  FilterList,
  SupervisedUserCircle,
  ArrowForwardIos,
  Close,
  Forum,
} from "@material-ui/icons";
import { withLocalize, Translate } from "react-localize-redux";
import { useHistory } from "react-router-dom";

import { makeStyles } from "@material-ui/styles";

import { AdminService, Validator } from "./../../../utils/web_config";

import Format from "date-fns/format";
import { useSnackbar } from "notistack";
import { Autocomplete } from "@material-ui/lab";

import { useOperators } from "../hooks/use_hooks";
import Typing from "../../../assets/svg/typing.svg";

import axiosRetry from "axios-retry";
const axios = require("axios");
axiosRetry(axios, { retries: 3 });
const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    [theme.breakpoints.up("sm")]: {
      marginLeft: 250,
    },
  },
  title: {
    flexGrow: 1,
  },
  btn: {
    textTransform: "capitalize",
  },
  btn2: {
    textTransform: "capitalize",
    border: "dashed grey 1px",
  },
  paper: {
    padding: 15,
  },
  action: {
    borderRadius: 15,
  },
}));

function Messaging(props) {
  const classes = useStyles();
  const history = useHistory();
  const operators = useOperators();
  const [accountData, setAccountData] = useState({});

  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const [messages, setMessages] = useState({
    saving: false,
  });

  const [messageType, setType] = useState({ value: "SMS", error: "" });
  const [messageReceiver, setReceiver] = useState({ value: "ALL", error: "" });
  const [messageOperator, setOperator] = useState({ value: {}, error: "" });
  const [messageContent, setContent] = useState({ value: "", error: "" });

  useEffect(() => {
    var accountData = new AdminService().accountData;
    setAccountData(accountData);
  }, []);

  //////////
  const onTypeChange = (event) => {
    if (event.target.value === "") {
      setType({
        value: "",
        error: (
          <Translate>
            {({ translate }) => translate("messaging.forms.hints.message_type")}
          </Translate>
        ),
      });
    } else {
      setType({ value: event.target.value, error: "" });
    }
  };
  const onReceiverChange = (event) => {
    if (event.target.value === "") {
      setReceiver({
        value: "",
        error: (
          <Translate>
            {({ translate }) =>
              translate("messaging.forms.hints.message_receiver")
            }
          </Translate>
        ),
      });
    } else {
      setReceiver({ value: event.target.value, error: "" });
    }
  };
  const onOperatorChange = (event, v) => {
    if (v?.organization_id == null) {
      setOperator({
        value: {},
        error: (
          <Translate>
            {({ translate }) =>
              translate("messaging.forms.hints.message_operator")
            }
          </Translate>
        ),
      });
    } else {
      setOperator({ value: v, error: "" });
    }
  };
  const onContentChange = (event) => {
    if (event.target.value === "") {
      setContent({
        value: "",
        error: (
          <Translate>
            {({ translate }) =>
              translate("messaging.forms.hints.message_content")
            }
          </Translate>
        ),
      });
    } else {
      setContent({ value: event.target.value, error: "" });
    }
  };

  ////////////////

  const onSendClick = () => {
    if (messageType.value === "") {
      setType({
        value: "",
        error: (
          <Translate>
            {({ translate }) => translate("messaging.forms.hints.message_type")}
          </Translate>
        ),
      });
    } else if (messageReceiver.value === "") {
      setReceiver({
        value: "",
        error: (
          <Translate>
            {({ translate }) =>
              translate("messaging.forms.hints.message_receiver")
            }
          </Translate>
        ),
      });
    } else if (
      messageOperator.value?.organization_id == null &&
      messageReceiver.value === "SINGLE"
    ) {
      setOperator({
        value: {},
        error: (
          <Translate>
            {({ translate }) =>
              translate("messaging.forms.hints.message_operator")
            }
          </Translate>
        ),
      });
    } else if (messageContent.value === "") {
      setContent({
        value: "",
        error: (
          <Translate>
            {({ translate }) =>
              translate("messaging.forms.hints.message_content")
            }
          </Translate>
        ),
      });
    } else {
      sendMessage();
    }
  };
  ////////////
  const notify = (variant, msg, status) => {
    if (status == 401) {
      history.push("/", { expired: true });
    }

    enqueueSnackbar(msg, {
      variant: variant,
      action: (k) => (
        <IconButton
          onClick={() => {
            closeSnackbar(k);
          }}
          size="small"
        >
          <Close fontSize="small" />
        </IconButton>
      ),
    });
  };
  ///////////////

  const sendMessage = () => {
    const sendInstance = axios.create(
      new AdminService().getHeaders(accountData.token)
    );
    setMessages({ ...messages, saving: true });

    var data, url;
    if (messageReceiver.value == "ALL") {
      url = new AdminService().BROADCAST_MESSAGE;
      data = {
        message_content: messageContent.value,
        message_type: messageType.value,
        organization_id: 0,
      };
    } else {
      url = new AdminService().SEND_MESSAGE;
      data = {
        message_content: messageContent.value,
        message_type: messageType.value,
        organization_id: messageOperator.value?.organization_id,
      };
    }

    console.log("Sending message .....");

    sendInstance
      .post(url, data)
      .then(function (response) {
        setMessages({ ...messages, saving: false });

        var d = response.data;
        console.log(d);

        notify("success", response.data.data);

        setContent({ value: "", error: "" });
        // setType({ value: "", error: "" });
        // setOperator({ value: {}, error: "" });
        // setReceiver({ value: "", error: "" });
      })
      .catch(function (error) {
        //console.log(error);
        setMessages({ ...messages, saving: false });

        var e = error.message;

        if (error.response) {
          e = error.response.data.message;
        }
        notify(error?.response?.status==404?"info":"error", e, error?.response?.status);
      });
  };

  return (
    <div className={classes.root}>
      {/* Dialogs ends here */}
      <Box display="flex" alignItems="center">
        <Box mr={2}>
          {" "}
          <Forum color="primary" fontSize="large" />
        </Box>
        <Box flexGrow={1} display="flex" alignItems="center">
          <Typography variant="h5">
            <b>Message broadcast</b>
          </Typography>
        </Box>
      </Box>
      <Box mt={3} />
      <Container maxWidth="lg">
        <Paper style={{ padding: 15 }} elevation={0}>
          <Box p={2}>
            <Typography color="textSecondary">
              Send SMS message or Emails to all operators or just the specific
              one.
            </Typography>
          </Box>

          <Grid container spacing={1} justify="center">
            <Grid item xs={12} md={7}>
              <Box m={3} display="flex" justifyContent="center" width={1}>
                <img src={Typing} alt="Type message" height={160} />
              </Box>
            </Grid>
            <Grid item xs={12} md={6}>
              <Box mt={2}>
                <FormControl
                  fullWidth
                  variant="outlined"
                  size="small"
                  error={messageType.error !== ""}
                >
                  <InputLabel>
                    <Translate id="messaging.forms.labels.message_type" />
                  </InputLabel>
                  <Select
                    label={
                      <Translate id="messaging.forms.labels.message_type" />
                    }
                    value={messageType.value}
                    onChange={onTypeChange}
                  >
                    {[
                      { id: "SMS", name: "SMS" },
                      { id: "EMAIL", name: "EMAIL" },
                      { id: "EMAIL_AND_SMS", name: "SMS and EMAIL" },
                    ].map((t, i) => (
                      <MenuItem value={t.id}>{t.name}</MenuItem>
                    ))}
                  </Select>
                  <FormHelperText>{messageType.error}</FormHelperText>
                </FormControl>
              </Box>
              <Box mt={2}>
                <FormControl
                  fullWidth
                  variant="outlined"
                  size="small"
                  error={messageReceiver.error !== ""}
                >
                  <InputLabel>
                    <Translate id="messaging.forms.labels.message_receiver" />
                  </InputLabel>
                  <Select
                    label={
                      <Translate id="messaging.forms.labels.message_receiver" />
                    }
                    value={messageReceiver.value}
                    onChange={onReceiverChange}
                  >
                    {[
                      { id: "ALL", name: "All operators" },
                      { id: "SINGLE", name: "Single operator" },
                    ].map((re, i) => (
                      <MenuItem value={re.id}>{re.name}</MenuItem>
                    ))}
                  </Select>
                  <FormHelperText>{messageReceiver.error}</FormHelperText>
                </FormControl>
              </Box>
              {messageReceiver.value != "ALL" && (
                <Box mt={2}>
                  <Autocomplete
                    fullWidth
                    openOnFocus
                    disabled={operators.status != "success"}
                    options={operators?.data}
                    getOptionLabel={(option) => option.name}
                    onChange={onOperatorChange}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        fullWidth
                        label={
                          <Translate id="messaging.forms.labels.message_operator" />
                        }
                        variant="outlined"
                        size="small"
                        helperText={
                          operators.status == "error"
                            ? "Error loading operators, please reload"
                            : operators.status == "empty"
                            ? "There are no operators available"
                            : messageOperator.error
                        }
                        error={
                          messageOperator.error !== "" ||
                          operators.status == "error" ||
                          operators.status == "empty"
                        }
                      />
                    )}
                  />
                </Box>
              )}
              <Box mt={2}>
                <Translate>
                  {({ translate }) => (
                    <TextField
                      size="small"
                      variant="outlined"
                      color="primary"
                      type="text"
                      multiline
                      rows={5}
                      rowsMax={8}
                      value={messageContent.value}
                      placeholder={translate(
                        "messaging.forms.hints.message_content"
                      )}
                      label={
                        <Translate id="messaging.forms.labels.message_content" />
                      }
                      fullWidth
                      onChange={onContentChange}
                      helperText={messageContent.error}
                      error={messageContent.error !== ""}
                    />
                  )}
                </Translate>
              </Box>
              <Box width={1} mt={2} display="flex" justifyContent="flex-end">
                {" "}
                <Button
                  disabled={messages.saving}
                  variant="contained"
                  color="primary"
                  onClick={onSendClick}
                  disableElevation
                >
                  {messages.saving ? (
                    <CircularProgress size={23} />
                  ) : (
                    "Send message"
                  )}
                </Button>
              </Box>
            </Grid>
          </Grid>
        </Paper>
      </Container>
    </div>
  );
}

export default withLocalize(Messaging);
